import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/ppic.png";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiFillTwitterCircle,
  AiFillInstagram,
  AiFillRedditCircle,
} from "react-icons/ai";
import { RiMessengerFill } from "react-icons/ri";
import { FaSnapchat, FaTwitch, FaTiktok } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="lime"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I had interest in tech ever since I was a kid. I've always loved the fact that gadgets can make our lives easier. 
              That's when I decided I want to be a part of this. My goal is to develop softwares and solutions that can make our everyday life better.
              <br />
              <br />My most used programming languages are
                <b className="lime"> C#, JavaScript and Python</b>.
              <br />
              <br />
              My field of interests are building new&nbsp;
                <b className="lime">Desktop and Web Technologies</b>,
                also areas related to{" "}
                <b className="lime">
                  AI
                </b>.
              <br />
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" style={{ width: '60%' }}/>
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON SOCIAL MEDIA</h1>
            <p>
              Feel free to <span className="lime">contact </span>me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/iklevente"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/iklevi.exe"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://m.me/iklevente"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <RiMessengerFill />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.reddit.com/u/KAISTEP"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillRedditCircle />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://twitch.tv/levikek03"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaTwitch />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://twitter.com/iklevente"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillTwitterCircle />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://snapchat.com/add/iklevente"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaSnapchat />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://tiktok.com/@iklevente"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaTiktok />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
